export default __webpack_public_path__ + "static/SRUS CS1 - Especification Del Producto y Datos Técnicos-174433aa50224988d1d64afeedfb120e.pdf";